module.exports = __webpack_public_path__ + "img/started_photo_1.46abab79.png";